import ConsequenceRosterSidePanel from './consequence-roster-side-panel';
export default ConsequenceRosterSidePanel;
